module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/aoj_b-5-b77f879658f5d13caeafed1277d2e94a.jpg";